"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var Chip_1 = __importDefault(require("./Chip"));
exports.Chip = Chip_1.default;
exports.default = Chip_1.default;
//# sourceMappingURL=index.js.map